import { render, staticRenderFns } from "./TaxModal.vue?vue&type=template&id=75422974&scoped=true&"
import script from "./TaxModal.vue?vue&type=script&lang=js&"
export * from "./TaxModal.vue?vue&type=script&lang=js&"
import style0 from "./TaxModal.vue?vue&type=style&index=0&id=75422974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75422974",
  null
  
)

export default component.exports